import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import CompanyProtectedRoute from './CompanyProtectedRoute';
import Navbar from '../../components/Navbar';
// import Footer from "../components/Footer";

// Auth Components
import CompanySignup from '../auth/Signup';
import CompanyLogin from '../auth/Login';
import VerifyEmail from '../auth/VerifyEmail';
import RequestVerification from '../auth/RequestVerification';
import ForgotPasswordPage from '../auth/ForgotPassword';
import ResetPassword from '../auth/ResetPassword';

// Layout Component
import DashboardLayout from '../pages/company_dashboard/DashboardLayout';

// Dashboard Components
import DashboardContent from '../pages/company_dashboard/DashboardContent';

// Brand Section Components
import BrandContent from '../pages/brand_sections/BrandContent';
import CreateBrands from '../pages/brand_sections/CreateBrands';
import BrandList from '../pages/brand_sections/BrandList';
import EditBrand from '../pages/brand_sections/EditBrand';
import ViewBrand from '../pages/brand_sections/ViewBrand';
import BrandManagers from '../pages/brand_sections/BrandManagers';
import BrandManagersDashboard from '../pages/brand_sections/BrandManagersDashboard';
import EditBrandManager from '../pages/brand_sections/EditBrandManager';

// Campaign Section Components
import CampaignContent from '../pages/campaign_sections/CampaignContent';
import CreateCampaign from '../pages/campaign_sections/CreateCampaign';
import CampaignList from '../pages/campaign_sections/CampaignList';
import ViewCampaign from '../pages/campaign_sections/ViewCampaign';
import EditCampaign from '../pages/campaign_sections/EditCampaign';
import CampaignLinkStats from '../pages/campaign_sections/CampaignLinkStats';
import CampaignAnalytics from '../pages/campaign_sections/CampaignAnalytics';
import CampaignAffiliateStats from '../pages/campaign_sections/CampaignAffiliateStats';
import AffiliatePaymentDetails from '../pages/campaign_sections/AffiliatePaymentDetails';
import CampaignAdvertising from '../pages/campaign_sections/CampaignAdvertising';
import AddInfluencerDetails from '../pages/campaign_sections/AddInfluencerDetails';
import AddAgencyDetails from '../pages/campaign_sections/AddAgencyDetails';
import AddInfluencerPreview from '../pages/campaign_sections/AddInfluencerPreview';
import AddAgencyPreview from '../pages/campaign_sections/AddAgencyPreview';
import ViewAdvertisingCampaign from '../pages/campaign_sections/ViewAdvertisingCampaign';
import CampaignApplicants from '../pages/campaign_sections/CampaignApplicants';
// Affiliate Section Components
import AffiliateContent from '../pages/affiliate_sections/AffiliateContent';
import InviteAffiliate from '../pages/affiliate_sections/InviteAffiliate';
import AddAffiliates from '../pages/affiliate_sections/AddAffiliates';
import AffiliateList from '../pages/affiliate_sections/AffiliateList';
import ViewAffiliate from '../pages/affiliate_sections/ViewAffiliate';
import EditAffiliate from '../pages/affiliate_sections/EditAffiliate';
import AffiliateCampaigns from '../pages/affiliate_sections/AffiliateCampaigns';
import AffiliateAnalytics from '../pages/affiliate_sections/AffiliateAnalytics';
import AddAffiliateCampaigns from '../pages/affiliate_sections/AddAffiliateCampaigns';
import AffiliateMarketplace from '../pages/affiliate_sections/AffiliateMarketplace';

// Pipeline
import PipelinePage from '../pages/pipeline_section/PipelinePage';

// Social Accounts
import CompanySocialAccountsPage from '../pages/social_accounts/CompanySocialAccountsPage';

// DM Automation
import DmAutomationPage from '../pages/dm_automation/DmAutomationPage';
import InstagramAutomation from '../pages/dm_automation/InstagramAutomation';

// Financial Section Components
import FinancialContent from '../pages/financial_sections/FinancialContent';
import FinancialTransaction from '../pages/financial_sections/FinancialTransaction';
import CalculatePayments from '../pages/financial_sections/CalculatePayments';
import PaymentRecords from '../pages/financial_sections/PaymentRecords';

// YouTube Media Approval Component
import YouTubeMediaApproval from '../pages/campaign_sections/YouTubeMediaApproval';

// Instagram Media Approval Component
import InstagramMediaApproval from '../pages/campaign_sections/InstagramMediaApproval';

// Other Section Components
import ReportsContent from '../pages/reports_sections/ReportsContent';

import SettingsContent from '../pages/settings_sections/SettingsContent';

// Profile Components
import CompanyProfile from '../company_pages/CompanyProfile';
import EditCompanyProfile from '../company_pages/EditCompanyProfile';
// import NotFoundPage from '../components/NotFoundPage';

const CompanyRoutes = () => {
  return (
    <> 
    <Navbar/>
    <Routes>
      {/* Public Auth Routes */}
      <Route path="signup" element={<CompanySignup />} />
      <Route path="login" element={<CompanyLogin />} />
      <Route path="verify-email" element={<VerifyEmail />} />
      <Route path="request-verification" element={<RequestVerification />} />
      <Route path="forgot-password" element={<ForgotPasswordPage />} />
      <Route path="reset-password/:token" element={<ResetPassword />} />

      {/* Profile Routes */}
      <Route path="profile" element={<CompanyProfile />} />
      <Route path="edit-profile" element={<EditCompanyProfile />} />

      {/* Protected Dashboard Routes */}
      <Route
        path="dashboard/*"
        element={
          <CompanyProtectedRoute>
            <DashboardLayout>
              <Routes>
                <Route path="/" element={<DashboardContent />} />
                <Route path="overview" element={<DashboardContent />} />
                {/* Brand Section */}
                <Route path="brands" element={<BrandContent />}>
                  <Route index element={<BrandList />} />
                  <Route path="create" element={<CreateBrands />} />
                  <Route path="edit/:id" element={<EditBrand />} />
                  <Route path="view/:id" element={<ViewBrand />} />
                  <Route path="brand-managers" element={<BrandManagers />} />
                  <Route path="brand-managers/dashboard" element={<BrandManagersDashboard />} />
                  <Route path="brand-managers/edit/:id" element={<EditBrandManager />} />
                </Route>

                {/* Campaign Section */}
                <Route path="campaigns" element={<CampaignContent />}>
                  <Route index element={<CampaignList />} />
                  <Route path="create" element={<CreateCampaign />} />
                  <Route path="view/:id" element={<ViewCampaign />} />
                  <Route path="edit/:id" element={<EditCampaign />} />
                  <Route path=":id/stats" element={<CampaignLinkStats />} />
                  <Route path="analytics" element={<CampaignAnalytics />} />
                  <Route path=":campaignId/affiliate-stats" element={<CampaignAffiliateStats />} />
                  <Route path=":campaignId/affiliate/:affiliateId/payment" element={<AffiliatePaymentDetails />} />
                  <Route path="advertising/create" element={<CampaignAdvertising />} />
                  <Route path="advertising/view" element={<ViewAdvertisingCampaign />} />
                  <Route path="advertising/:advertisingId/applicants" element={<CampaignApplicants />} />
                  <Route path="advertising/add-details" element={<AddInfluencerDetails />} />
                  <Route path="advertising/add-agency-details" element={<AddAgencyDetails />} />
                  <Route path="advertising/add-details/preview" element={<AddInfluencerPreview />} />
                  <Route path="advertising/add-agency-details/preview" element={<AddAgencyPreview />} />
                </Route>

                {/* YouTube Media Approval */}
                <Route path="youtube-media-approval" element={<YouTubeMediaApproval />} />

                {/* Instagram Media Approval */}
                <Route path="instagram-media-approval" element={<InstagramMediaApproval />} />

                {/* Affiliate Section */}
                <Route path="affiliates" element={<AffiliateContent />}>
                  <Route index element={<AffiliateList />} />
                  <Route path="create" element={<InviteAffiliate />} />
                  <Route path="add" element={<AddAffiliates />} />
                  <Route path="view/:id" element={<ViewAffiliate />} />
                  <Route path="edit/:id" element={<EditAffiliate />} />
                  <Route path="affiliate-campaigns/:email" element={<AffiliateCampaigns />} />
                  <Route path="add-campaigns/:userId" element={<AddAffiliateCampaigns />} />
                  <Route path="analytics" element={<AffiliateAnalytics />} />
                  <Route path="marketplace" element={<AffiliateMarketplace />} />
                </Route>

                <Route path="pipelines" element={<PipelinePage />} />
                <Route path="social-accounts" element={<CompanySocialAccountsPage />} />
                <Route path="dm-automation" element={<DmAutomationPage />} />
                <Route path="dm-automation/create" element={<InstagramAutomation />} />
                <Route path="dm-automation/edit/:id" element={<InstagramAutomation />} />

                {/* Financial Section */}
                <Route path="financial" element={<FinancialContent />}>
                  <Route path="transactions" element={<FinancialTransaction />} />
                  <Route path="calculate" element={<CalculatePayments />} />
                  <Route path="records" element={<PaymentRecords />} />
                </Route>
            
                {/* Other Dashboard Sections */}
                <Route path="reports" element={<ReportsContent />} />
              
                <Route path="settings" element={<SettingsContent />} />
              </Routes>
            </DashboardLayout>
          </CompanyProtectedRoute>
        }
      />

      {/* Redirect root to login if not authenticated */}
      <Route path="" element={<Navigate to="login" replace />} />
      
      {/* Catch all undefined routes and redirect to dashboard */}
      <Route path="*" element={<Navigate to="dashboard" replace />} />
      {/* <Route path="*" element={<NotFoundPage />} /> */} 
    </Routes>
    {/* <Footer/> */}
    </>
  );
};
export default CompanyRoutes; 
